import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import useFetchCsrfToken from "../../0. Utilidades/useFetchCsrfToken";
import "../Maestra.css";

function Bios({ maestraRut, bios, tipo, relacion, onBiosUpdate }) {
  const [showModal, setShowModal] = useState(false);
  const [newBios, setNewBios] = useState(bios || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // NEW: loading state for Estado toggle
  const [isTogglingEstado, setIsTogglingEstado] = useState(false);

  const csrfToken = useFetchCsrfToken();

  const handleSaveBios = async () => {
    setIsSubmitting(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestraRut}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({ bios: newBios }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to update bios");
      }

      onBiosUpdate();
      setShowModal(false);
    } catch (error) {
      console.error("Error updating bios:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // NEW: Toggle Estado (OK <-> Problema)
  const handleToggleEstado = async () => {
    if (isTogglingEstado) return;

    setIsTogglingEstado(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestraRut}/toggle_estado/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Failed to toggle estado");
      }

      // Refresh parent data so the UI shows the updated estado
      onBiosUpdate();
    } catch (error) {
      console.error("Error toggling estado:", error);
    } finally {
      setIsTogglingEstado(false);
    }
  };

  // Convert tipo and relacion to lowercase with dashes for class names
  const tipoClass = tipo ? tipo.toLowerCase().replace(" ", "-") : "";
  const relacionClass = relacion ? relacion.toLowerCase().replace(" ", "-") : "";

  return (
    <>
      <div id="maestra-badge">
        <div className={`maestra-badge-tipo ${tipoClass}`}>
          <span>Tipo de Perfil:</span>
          <span>{tipo}</span>
        </div>

        {/* UPDATED: Estado is now clickable */}
        <div
          className={`maestra-badge-relacion ${relacionClass}`}
          onClick={handleToggleEstado}
          style={{ cursor: "pointer" }}
          title="Click to toggle Estado (OK / Problema)"
        >
          <span>Estado:</span>
          <span>{isTogglingEstado ? "Actualizando..." : (relacion || "OK")}</span>
        </div>
      </div>

      <div className="maestra-bios-section">
        <p className="maestra-bios-text" onClick={() => setShowModal(true)}>
          {bios || "Agregar historia de vida..."}
        </p>

        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Historia de Vida</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Control
                  as="textarea"
                  rows={5}
                  value={newBios}
                  onChange={(e) => setNewBios(e.target.value)}
                  placeholder="Esto es un resumen de la historia de la Maestra..."
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowModal(false)}
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={handleSaveBios}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default Bios;
